module.exports = __webpack_public_path__ + "img/grid-sample4.531063c1.jpg";